import React from 'react';
import { PapiGallection } from '@wix/da-papi-types';
import SubfoldersIcon from '@wix/da-ds/pkg/Icons/24x24/Subfolders';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import GallectionCoverDumbo from '../../GallectionCoverDumbo/GallectionCoverDumbo';
import folderSropdownDesktopStyles from './FolderDropdownDesktop.scss';

export interface Props {
  folder: PapiGallection;
  hasSubfolders: boolean;
}

const FolderThumb: React.FC<Props> = ({ folder, hasSubfolders }) => {
  const previewProps = {
    width: 86,
    height: 48,
  };

  return (
    <div className={folderSropdownDesktopStyles['thumb-wrapper']}>
      <GallectionCoverDumbo
        {...previewProps}
        gallection={folder}
        className={folderSropdownDesktopStyles['thumb']}
      />
      {hasSubfolders && (
        <SubfoldersIcon
          size={IconSize.SMALL}
          className={folderSropdownDesktopStyles['subfolders-icon']}
        />
      )}
    </div>
  );
};
FolderThumb.displayName = 'FolderThumb';

export default FolderThumb;
